import ContentSpinner from './ContentSpinner';

export default ContentSpinner;
